import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { space } from 'styled-system';
import PropTypes from 'prop-types';
import Icon from '../Icon';

const RadioInput = styled.input`
  appearance: none;
  opacity: 0;
  position: absolute;
  z-index: 0;
  cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};
  &:focus {
    box-shadow: none;
  }
  &:checked ~ svg {
    color: ${(p) => p.theme.colors.black};
  }
  &:disabled ~ svg {
    color: ${(p) => p.theme.colors.black};
    opacity: 0.4;
  }
`;

const RadioWrap = styled.label`
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  font-size: ${(props) => props.theme.fontSizes[1]};
  color: lighten(${(p) => p.theme.colors.black}, 10%);
  cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};
  user-select: none;
  ${space};
`;

RadioWrap.defaultProps = {
  mb: 3,
  mr: 6,
};

RadioWrap.propTypes = {
  ...space.propTypes,
};

const Radio = forwardRef(({
  onChange,
  value,
  checked,
  disabled,
  label,
  name,
  children,
  ...rest
}, ref) => (
  <RadioWrap disabled={disabled} {...rest}>
    <RadioInput name={name} type="radio" ref={ref} onChange={onChange} value={value} checked={checked} disabled={disabled} />
    <Icon name={checked ? 'SelectedCircle' : 'EmptyCircle'} size={6} mr="3" />
    {children || label}
  </RadioWrap>
));
export default Radio;

Radio.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  label: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  ...space.propTypes,
};

Radio.defaultProps = {
  onChange: () => {},
  checked: false,
  disabled: false,
  label: '',
  name: '',
  children: null,
};
